import { render, staticRenderFns } from "./editDescriptionAndComments.vue?vue&type=template&id=0720a577&scoped=true&"
import script from "./editDescriptionAndComments.vue?vue&type=script&lang=js&"
export * from "./editDescriptionAndComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720a577",
  null
  
)

export default component.exports